import React from 'react';
import Joi from 'joi-browser';
import * as _ from 'lodash';
import Moment from 'moment';
import regex from '../utilities/validateRegex';
import { validationByJoi } from '../utilities/commonValidation';

import InfinityScrollLoad from '../components/InfinityScrollLoad';

import { JobService } from '../services/Jobs';

import { JobContents } from '../components/tables/Job';

import _masterSlideLoader from '../utilities/masterSlideLoader';
import { Delete } from './modals/Commons';
import dialogLoader from '../utilities/dialogLoader';
import * as dialog from '../components/FieldTreeDialog';
import Helmet from 'react-helmet';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { csvDownloader } from '../utilities/commonUtil';
import { messageUtility } from '../utilities/messageUtility';
import { TouchDeviceInvisible } from '../components/TouchDeviceInvisible';
import { deleteControlCode } from '../utilities/stringUtil';
import { MasterPageHeader } from '../components/PageHeader';

/**
 * @description 職種一覧画面
 */
export class Jobs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      roleId: localStorage.getItem('role_id'),
      total: 0,
      loaded: false,
      jobs: [],
      canDrop: false, //ドラッグアンドドロップの状態
      searched: false, //検索の状態
      dragSort: [], //ドラッグアンドドロップの並び順の仮置き場
      searchParam: {
        display_flag: '',
        company_branch_id: '',
        name: '',
      },
      csvSearchConditions: {
        fullname: '', // 名前
        user_role_code: '', // 種別
      }, // 検索条件(CSV用)
      orderParam: {
        order: 'order_number_asc',
      },
      isOpened: false,
      isSettingId: null,
      formValues: {},
      errors: {},
      validateName: '',
      params: {
        // 絞り込み処理で更新するので stateで保持
        offset: 0,
        limit: 30,
      },
      search_form_open: false, // search_form の開閉
      date: Moment().format('YYYYMMDDHHmm'),
      isLoading: true, // ロード中フラグ
      isRegisterWaiting: false,
    };
    this.defaultValues = {
      id: null,
      display_flag: 1,
      name: '',
      kana: '',
    };
    this.events = {
      form: {
        handle: this.handleSearchFormShow.bind(this),
        setFormValues: this.setFormValues.bind(this),
        clearFormValues: this.clearFormValues.bind(this),
        set: this.setFlatData.bind(this),
        validate: this.validate.bind(this),
        submit: this.eventSubmit.bind(this),
        clearSearchParam: this.onClearSearchParam.bind(this),
        changeSearchParam: this.onChangeSearchParam.bind(this),
        execution: this.searchExecution.bind(this), // 検索実行
        csv: this.csvDownloadPreparation.bind(this),
      },
      modal: {
        deleteModal: this.deleteModal.bind(this),
        delete: this.deleteJob.bind(this),
      },
      //ドラッグアンドドロップ用メソッド
      dnd: {
        onHover: this.onHover.bind(this),
        onBeginDrag: this.onBeginDrag.bind(this),
        onDropped: this.onDropped.bind(this),
        draggable: this.draggable.bind(this),
        orderSubmit: this.eventOrderSubmit.bind(this),
      },
    };
    this.schema = Joi.object().keys({
      id: Joi.allow(''),
      display_flag: Joi.allow(''),
      name: Joi.string()
        .max(255)
        .required(),
      kana: Joi.string()
        .max(255)
        .regex(regex.pattern.hiragana)
        .required(),
    });
    this.searchButtonRef = React.createRef(); // 検索ボタン要素
    this.isCSVRequestingFlag = false;
    this.isRequestingFlag = false;
  }

  componentDidMount() {
    this.setJobs();
  }

  async setJobs(orderParam, searchParam, notify) {
    if (this.state.loaded && notify) {
      notify();
      this.setState({ isLoading: false });
      return;
    }
    const pageParam = {
      offset: notify ? _.size(this.state.jobs) : 0,
    };

    const params = _.assign(orderParam, searchParam, pageParam);
    await JobService.list(params).then(resp => {
      if (resp.result) {
        const getjobs = resp.data.entities.jobs;
        if (_.isEmpty(getjobs) && notify) {
          this.setState({
            loaded: true,
          });
        } else {
          let jobs = notify ? this.state.jobs : [];
          _.each(getjobs, job => {
            jobs.push(job);
          });
          this.setState({
            jobs: _.cloneDeep(jobs),
            total: resp.data.total,
            loaded: false,
          });
        }
      }
      this.searchButtonRef.current.disabled = false;
      this.setState({ isLoading: false });
      if (notify) {
        notify();
        return;
      }
    });
  }

  /**
   * @description CSV出力準備
   */
  async csvDownloadPreparation() {
    if (this.isCSVRequestingFlag) {
      return;
    }
    this.isCSVRequestingFlag = true;
    const params = _.assign(
      this.state.orderParam,
      this.state.csvSearchConditions
    );
    const apiPath = 'api/private/jobs/list.csv';

    await csvDownloader(apiPath, params);
    this.isCSVRequestingFlag = false;
  }

  /**
   * ホバー
   */
  // eslint-disable-next-line no-unused-vars
  onHover(props, monitor, component) {}

  /**
   * ドラッグ開始
   */
  // eslint-disable-next-line no-unused-vars
  onBeginDrag(props, monitor, component) {
    let dragSort = _.cloneDeep(this.state.dragSort);
    dragSort[0] = props.index;
    this.setState({ dragSort });
  }

  /**
   * ドロップダウン
   */
  // eslint-disable-next-line no-unused-vars
  onDropped(dragProps, dropProps, monitor, dropComponent) {
    let dragSort = _.cloneDeep(this.state.dragSort);
    dragSort[1] = dropProps.index;
    this.setState({ dragSort });
    this.sortList(...this.state.dragSort);
  }

  /**
   * ドラッグ開始、終了
   */
  draggable(bool) {
    this.setState({ canDrag: bool });
  }

  /**
   * @description 並び順を変更する
   */
  sortList(dragIndex, to_index) {
    const lists = _.cloneDeep(this.state.jobs);
    const formItem = lists[dragIndex];
    if (to_index < dragIndex) {
      lists.splice(to_index, 0, formItem);
      lists.splice(dragIndex + 1, 1);
    } else {
      lists.splice(to_index + 1, 0, formItem);
      lists.splice(dragIndex, 1);
    }
    this.setState({ jobs: lists });
  }

  handleSearchFormShow = () => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  setFormValues = job => {
    const formValues = {};
    _.each(Object.keys(this.defaultValues), key => {
      formValues[key] = job[key];
    });
    this.setState({
      isSettingId: job.id ? job.id : 0,
      formValues,
      errors: {},
      validateName: job.name,
    });
  };

  clearFormValues = () => {
    this.setState({
      isSettingId: null,
      formValues: this.defaultValues,
      errors: {},
    });
  };

  onChangeSearchParam = e => {
    const searchParam = { ...this.state.searchParam };
    searchParam[e.target.name] = e.target.value;
    this.setState({ searchParam });
  };

  /**
   * @description 検索実行
   */
  searchExecution() {
    this.searchButtonRef.current.disabled = true;

    const searchParam = { ...this.state.searchParam };
    let searched = false;
    _.each(searchParam, value => {
      if (value !== '') {
        searched = true;
      }
    });

    this.setJobs(this.state.orderParam, searchParam);
    this.setState({
      searchParam,
      searched,
      csvSearchConditions: searchParam,
      isLoading: true,
      jobs: [],
    });
  }

  onClearSearchParam = async () => {
    if (this.isRequestingFlag) {
      return;
    }
    this.isRequestingFlag = true;
    const searchParam = {
      display_flag: '',
      company_branch_id: '',
      name: '',
    };
    this.setState({
      searchParam,
      searched: false,
      csvSearchConditions: searchParam,
      isLoading: true,
      jobs: [],
    });
    await this.setJobs(this.state.orderParam, searchParam);
    this.isRequestingFlag = false;
  };

  setFlatData = e => {
    let formValues = this.state.formValues;
    formValues[e.target.name] = deleteControlCode(e.target.value);
    this.setState({ formValues });
  };

  deleteModal(deleteId, callbacks) {
    dialogLoader.show(Delete, {
      state: {
        deleteId,
        callbacks,
      },
    });
  }

  deleteJob = id => {
    JobService.del(id).then(resp => {
      if (resp.result) {
        this.setJobs(this.state.orderParam, this.state.csvSearchConditions);
        this.setState({
          isSettingId: null,
          errors: {},
        });
        dialogLoader.close();
      } else {
        dialogLoader.show(dialog.NeverDeletePartnerCompany, {
          callback: {
            done: () => {
              dialogLoader.close();
            },
          },
        });
      }
    });
  };

  // 重複チェック
  duplicateCheck(name, errors) {
    const params = {
      limit: this.state.total,
    };
    return JobService.list(params).then(resp => {
      if (resp.result) {
        const listData = resp.data.entities.jobs;
        const names = _.map(listData, job => job.name);
        if (this.state.validateName !== this.state.formValues.name) {
          if (_.some(names, n => n === name)) {
            errors.name = messageUtility.getMessage('E-001-005');
            this.setState({
              errors,
            });
          }
        }
      }
    });
  }

  validate(e) {
    const params = this.state.formValues;
    const result = validationByJoi(this.schema, params);
    const errors = this.state.errors;
    //単数or複数判定
    if (e) {
      if (result.messages[e.target.name]) {
        errors[e.target.name] = result.messages[e.target.name];
      } else if (errors[e.target.name]) {
        delete errors[e.target.name];
      }
      this.setState({ errors });
      if (e.target.name == 'name') {
        this.duplicateCheck(e.target.value, errors);
      }
    } else {
      if (errors.name) {
        result.messages.name = errors.name;
      }
      this.setState({
        errors: result.messages,
      });
      return Object.keys(result.messages).length;
    }
  }

  eventSubmit() {
    if (this.state.isRegisterWaiting) {
      return;
    } else {
      this.setState(
        {
          isRegisterWaiting: true,
        },
        () => {
          let validate = this.validate();
          if (validate !== 0) {
            this.setState({
              isRegisterWaiting: false,
            });
            return;
          }
          const newState = {};
          const params = this.state.formValues;
          const id = params.id;
          if (id) {
            JobService.update(id, params)
              .then(resp => {
                if (resp.result) {
                  this.setJobs(this.state.orderParam, this.state.csvSearchConditions);
                  newState.isSettingId = null;
                  newState.errors = {};
                }
              })
              .finally(() => {
                newState.isRegisterWaiting = false;
                this.setState(newState);
              });
          } else {
            JobService.create(params)
              .then(resp => {
                if (resp.result) {
                  this.setJobs(this.state.orderParam, this.state.csvSearchConditions);
                  newState.isSettingId = null;
                  newState.errors = {};
                }
              })
              .finally(() => {
                newState.isRegisterWaiting = false;
                this.setState(newState);
              });
          }
        }
      );
    }
  }

  eventOrderSubmit = () => {
    const items = this.state.jobs;
    const params = { ids: _.map(items, 'id') };
    JobService.updateOrder(params).then(resp => {
      if (resp.result) {
        this.setJobs(this.state.orderParam, this.state.csvSearchConditions);
      }
    });
  };

  render() {
    return (
      <div id='slide-view' className='master-slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - 職種一覧</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <TitleHeader />
          <div id='infinityscroll-target' className='master-slide-view__table'>
            <HeaderMenu
              defaultValues={this.defaultValues}
              callbacks={this.events}
              searched={this.state.searched}
              isSettingId={this.state.isSettingId}
              canDrag={this.state.canDrag}
              roleId={this.state.roleId}
              date={this.state.date}
            />
            <SearchForm
              isOpened={this.state.isOpened}
              total={this.state.total}
              callbacks={this.events}
              searchParam={this.state.searchParam}
              canDrag={this.state.canDrag}
              searchButtonRef={this.searchButtonRef}
            />
            <JobContents
              jobs={this.state.jobs}
              roleId={this.state.roleId}
              values={this.state.formValues}
              errors={this.state.errors}
              isSettingId={this.state.isSettingId}
              callbacks={this.events}
              canDrag={this.state.canDrag}
              infinityScrollLoad={
                <InfinityScrollLoad
                  targetId='infinityscroll-target'
                  total={_.size(this.state.jobs)}
                  isLoading={this.state.isLoading}
                  callback={notifyEnd => {
                    this.setJobs(
                      this.state.orderParam,
                      this.state.csvSearchConditions,
                      notifyEnd
                    );
                  }}
                />
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

const TitleHeader = () => (
  <MasterPageHeader
    title={'職種一覧'}
    onClose={() => _masterSlideLoader.close()}
  />
);

const HeaderMenu = ({
  defaultValues,
  callbacks,
  searched,
  isSettingId,
  canDrag,
  roleId,
  // eslint-disable-next-line no-unused-vars
  date,
}) => {
  if (canDrag) {
    return (
      <div className='master-slide-view__menu'>
        <ul className='btn-menu'>
          <li className='btn-menu__item'>
            <button
              className='btn'
              onClick={() => {
                callbacks.dnd.orderSubmit();
                callbacks.dnd.draggable(false);
              }}
            >
              保存
            </button>
          </li>
        </ul>
      </div>
    );
  } else {
    if (roleId < 3) {
      return (
        <div className='master-slide-view__menu'>
          <ul className='btn-menu'>
            <li className='btn-menu__item'>
              <button
                className='btn'
                onClick={() => callbacks.form.setFormValues(defaultValues)}
                style={{
                  display: isSettingId !== null ? 'none' : 'inline-block',
                }}
              >
                新規作成
              </button>
            </li>
            <TouchDeviceInvisible>
              <li className='btn-menu__item'>
                <button
                  className='btn--sub'
                  onClick={() => callbacks.dnd.draggable(true)}
                  style={{
                    display:
                      searched || isSettingId !== null
                        ? 'none'
                        : 'inline-block',
                  }}
                >
                  並び順を変更する
                </button>
              </li>
            </TouchDeviceInvisible>
            <li className='--fx-auto' />
            <li className='btn-menu__item'>
              <button
                className='btn--sub'
                onClick={callbacks.form.csv}
                style={{
                  display: isSettingId !== null ? 'none' : 'inline-block',
                }}
              >
                表示データをCSV出力
              </button>
            </li>
          </ul>
        </div>
      );
    } else {
      return (
        <div className='master-slide-view__menu'>
          <ul className='btn-menu'>
            <li className='btn-menu__item'>
              ※職種マスターは本社管理者のみが追加・編集を行えます。
            </li>
            <li className='--fx-auto' />
            <li className='btn-menu__item'>
              <button className='btn--sub' onClick={callbacks.form.csv}>
                表示データをCSV出力
              </button>
            </li>
          </ul>
        </div>
      );
    }
  }
};

/**
 * @description 検索フォーム コンポーネント
 */
const SearchForm = ({
  isOpened,
  total,
  callbacks,
  searchParam,
  canDrag,
  searchButtonRef,
}) => (
  <div className='master-slide-view__searchform'>
    <div
      className='search-form'
      style={{ display: canDrag ? 'none' : 'inline-block' }}
    >
      <SearchFormHeader
        isOpened={isOpened}
        total={total}
        callbacks={callbacks}
      />
      <div
        id='search-form-accordion'
        className={isOpened ? 'accordion show' : 'accordion'}
      >
        <div className='search-form__body'>
          <div className='form form--search-form'>
            <div className='form__group flex-wrap'>
              <DisplayStatus callbacks={callbacks} searchParam={searchParam} />
              <JobName
                callbacks={callbacks}
                searchParam={searchParam}
                searchButtonRef={searchButtonRef}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const SearchFormHeader = ({ isOpened, total, callbacks }) => (
  <div className='search-form__header'>
    <div className='search-form__title'>
      検索条件（検索結果
      <span className='bold'>{total}</span>
      件)
    </div>
    <button
      id='setting-search-accordion-toggle'
      className={isOpened ? 'accordion__btn show' : 'accordion__btn'}
      onClick={() => callbacks.form.handle()}
    />
    <button
      className='btn-text--sm'
      onClick={() => callbacks.form.clearSearchParam()}
    >
      検索条件クリア
    </button>
  </div>
);

/**
 * @description 検索フォームの 支店名コンポーネント
 */
const DisplayStatus = ({ callbacks, searchParam }) => (
  <div className='form-element'>
    <div className='form-element__label'>
      <span className='label'>ステータス</span>
    </div>
    <div className='form-element__list'>
      <div className='element__item'>
        <label className='radio'>
          <input
            type='radio'
            name='display_flag'
            value={1}
            checked={searchParam.display_flag === '1'}
            onChange={e => callbacks.form.changeSearchParam(e)}
          />
          <i className='i-2x' />
          <span>使用中</span>
        </label>
      </div>
      <div className='element__item'>
        <label className='radio'>
          <input
            type='radio'
            name='display_flag'
            value={0}
            checked={searchParam.display_flag === '0'}
            onChange={e => callbacks.form.changeSearchParam(e)}
          />
          <i className='i-2x' />
          <span>未使用</span>
        </label>
      </div>
    </div>
  </div>
);

/**
 * @description 検索フォームの 職種名コンポーネント
 */
const JobName = ({ callbacks, searchParam, searchButtonRef }) => (
  <div className='form-element'>
    <div className='form-element__label'>
      <span className='label'>職種名</span>
    </div>
    <div className='form-element__element --col-xs-12 --col-md-12 --col-lg-9 --col-xl-8'>
      <input
        type='text'
        name='name'
        placeholder='職種名を入力'
        value={searchParam.name}
        onChange={e => callbacks.form.changeSearchParam(e)}
      />
      <button
        className='btn--sm--stay search-form__btn'
        ref={searchButtonRef}
        onClick={callbacks.form.execution}
      >
        検索
      </button>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/Jobs.jsx